import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';

import withResponsiveWrapper from '../../decorators/withResponsiveWrapper';
import { sortBy } from '../../helpers';
import { headerMessages as messages } from '../../defineMessages';

import Page from '../../components/Page/Page';
import Label from '../../components/Label';
import Link from '../../components/Link';
import Grid from '../../components/Grid';
import List from '../../components/List';
import s from './Occasions.scss';

const Occasions = ({ locale, occasions }) => {
  return (
    <Page>
      <Label tag="h1" bold className={s.title}>
        <FormattedMessage {...messages.occasions} />
      </Label>
      <Grid container spacing="fluid" className={s.container}>
        <List component="ol" className={s.list}>
          {occasions.sort(sortBy('label', 'asc', locale)).map(occasion => (
            <List item component="li" key={occasion.label}>
              <Link to={occasion.to} className={s.link}>
                {occasion.label}
              </Link>
            </List>
          ))}
        </List>
      </Grid>
    </Page>
  );
};

Occasions.propTypes = {
  occasions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      to: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    }),
  ).isRequired,
  locale: PropTypes.string.isRequired,
};

const mapState = state => ({
  occasions: state.config.menu.occasions,
  locale: state.intl.locale,
});

export default compose(
  connect(mapState),
  withStyles(s),
  withResponsiveWrapper(),
)(Occasions);
